import { render, staticRenderFns } from "./FormNavigator.vue?vue&type=template&id=af396cbc&scoped=true&"
import script from "./FormNavigator.vue?vue&type=script&lang=js&"
export * from "./FormNavigator.vue?vue&type=script&lang=js&"
import style0 from "./FormNavigator.vue?vue&type=style&index=0&id=af396cbc&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "af396cbc",
  null
  
)

export default component.exports